import React, {
  useCallback,
  useMemo,
  useState,
  useRef,
  useEffect,
} from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Modal,
  Select,
  TextField,
  Toast,
} from "@shopify/polaris";
import { useGetState } from "ahooks";
// import intl from "../../../../../../../../i18n/intl";
// * config
import ShopifyCountriesConfig from "../../../../../../../../assets/ShopifyCountries";
// * 自定义组件
import PlaceholderImage from "../../../../../../../../components/PlaceholderImage";
import EditAttribute from "./EditAttribute";
import Shipping from "./Shipping";
// * api
import _ from "lodash";
import { reqPostDropshipmanNewProductAction } from "../../../../../../../../api";
import intl from "../../../../../../../../i18n/intl";
import { store } from "../../../../../../../../store";
import { changeBannerData } from "../../../../../../../../slice";

/**
 *
 * @param {Object} data 商品详情
 * @param {Function} setRuleForm 修改商品详情方法
 * @param {Array} shippingData 物流方式列表数据
 * @param {Function} setShippingData 修改物流列表
 * @param {onSave} onSave 保存
 * @returns
 */
const VariantsTable = ({
  id,
  data,
  setRuleForm,
  shippingData,
  setShippingData,
  onSave,
  searchingShip,
  checkNum,
  setCurrentNum,
  productInfoData,
  productInfoSet,
}) => {
  const { t } = useTranslation();
  // const limit = 10;
  const height = 500;
  const tableRef = useRef();
  const theadRef = useRef();
  const scrollRef = useRef();
  // const [showMore, setShowMore, getShowMore] = useGetState(0);
  const [list, setList, getList] = useGetState(data?.Variants);
  const [origin, setOrigin] = useState(data?.Variants);
  const [changeAttributeData, setChangeAttributeData, getChangeAttributeData] =
    useGetState({
      ChangeAllPriceSelect: "",
      ChangeAllComparedPriceSelect: "",
      // 是否批量设置价格 price / Compared At Price
      isBulkSettingPrice: true,
      BulkSettingPriceType: "1", // 设置类型1：统一价格值,2:价格倍数因子c ,price*c
      BulkSettingPriceActive: false,
      PriceSettingValue: "",
    });
  useEffect(() => {
    let isMount = true;
    if (isMount) {
      setList(data?.Variants);
      setOrigin(data?.Variants);
    }
    return () => (isMount = false);
    // eslint-disable-next-line
  }, [data]);
  // 物流方式
  const [showShipping, setShowShipping] = useState(false); // 显示物流弹窗

  // 批量修改属性
  const [showAttribute, setShowAttribute] = useState(false); // 显示修改属性弹窗
  const [currentField, setCurrentField] = useState(""); // 当前修改的属性字段
  const [hasScroll, setHasScroll] = useState(true); // 判断是否需要展示滚动条

  useEffect(() => {
    setHasScroll(scrollRef.current?.getBoundingClientRect()?.height > height);
  }, []);

  // 打开修改属性弹窗
  const openAttribute = (type) => {
    setShowAttribute(true);
    setCurrentField(type);
  };

  // 批量修改属性
  const batchChangeAttribute = useCallback(
    async (inputValue) => {
      setCurrentNum(false);
      _.forEach(origin, (item) => {
        if (item.checked) {
          item[currentField] = inputValue;
        }
      });
      setList(origin);
      setOrigin(origin);
      await setRuleForm((preState) => {
        let currentData = preState.variants;
        let param = { ...currentData, Variants: origin };
        const params = { ...preState, variants: param };
        return params;
      });
      onSave("variants",'modified');
    },
    // eslint-disable-next-line
    [origin, currentField]
  );

  // 单选
  const handleCheck = useCallback(
    async (item) => {
      setCurrentNum(false);
      // const list = _.cloneDeep(data.Variants);
      const list = [...origin];
      _.forEach(list, (el) => {
        if (el.id === item.id) {
          const checked = el.checked === 1 ? 0 : 1;
          el.checked = item.checked = checked;
        }
      });
      setList(list);
      setOrigin(list);
      await setRuleForm((preState) => {
        let currentData = preState.variants;
        let param = { ...currentData, Variants: list };
        const params = { ...preState, variants: param };
        return params;
      });
      // 单个保存
      handleSave(item);
    },
    // eslint-disable-next-line
    [origin]
  );

  // 单选保存
  const handleSave = async (item) => {
    // const params = {
    //   actionType: "variants",
    //   RecordId: item.dropshipman_user_product_id,
    //   variantId: item.id,
    //   field: "checked",
    //   fieldValue: item.checked,
    // };
    setCurrentNum(false);
    onSave("variants");
  };

  // 全选
  const checkAll = useCallback(async () => {
    // const list = _.cloneDeep(data.Variants);
    // _.forEach(list, (item) => {
    setCurrentNum(false);
    const list = [...origin];
    // _.forEach(list, (item) => {
    //   if (isCheckAll === "indeterminate") {
    //     item.checked = 1;
    //   } else {
    //     item.checked = isCheckAll ? 0 : 1;
    //   }
    // });
    const list1 = _.filter(list, (item) => item.checked);
    if (list.length >= 0) {
      if (isCheckAll === "indeterminate" && list1.length === 0) {
        _.forEach(list.slice(0, 100), (item) => {
          item.checked = 1;
        });
      } else {
        _.forEach(list, (item) => {
          item.checked = 0;
        });
      }
      if (list1.length < 100 && list1.length < list.length) {
        _.forEach(list.slice(0, 100), (item) => {
            item.checked = 1;
        });
      }else{
        _.forEach(list, (item) => {
          item.checked = 0;
      });
      }

      if (isCheckAll === true) {
        _.forEach(list.slice(100, list.length), (item) => {
          item.checked = 0;
        });
      }
    }
    setList(list);
    setOrigin(list);
    // await setRuleForm((preState) => ({ ...preState, Variants: list }));
    await setRuleForm((preState) => {
      let currentData = preState.variants;
      let param = { ...currentData, Variants: list };
      const params = { ...preState, variants: param };
      return params;
    });
    onSave("variants");
    // eslint-disable-next-line
  }, [origin]);

  // 全选状态
  const isCheckAll = useMemo(() => {
    const list = _.filter(origin, (item) => item.checked);
    if (_.isEmpty(list)) {
      return false;
    } else if (list.length > 0 && list.length === origin.length) {
      return true;
    }
    return "indeterminate";
  }, [origin]);
  // 修改属性名称（key）
  const changeAttribute = useCallback(
    (field, value) => {
      setCurrentNum(false);
      setRuleForm((preState) => {
        let currentData = preState.variants;
        let param = {
          ...currentData,
          Options: {
            ...currentData.Options,
            [field]: value,
          },
        };
        const params = { ...preState, variants: param };
        return params;
      });
    },
    // eslint-disable-next-line
    [data.Options]
  );
  const allSelect = () => {
    let text = false;
    const list = _.filter(origin, (item) => item.checked);
    if (list.length >= 100) {
      text = true;
    }
    return text;
  };
  // 保存属性名称（key）
  const saveAttribute = async (type, value) => {
    const params = {
      actionType: "option",
      RecordId: id,
      type: type,
      value,
    };
    let item1 = optionData("option_one")
    let item2 = optionData("option_two")
    let item3 = optionData("option_three")
    // const formData = new FormData();
    // for (const key in params) {
    //   formData.append(key, params[key]);
    // }
   
   
    setCurrentNum(false);
    const res = await reqPostDropshipmanNewProductAction(params);
    if (res && res.code === "200") {
      let text = 1;
      let list = productInfoData.map((it) => {
        if (it.id === id) {
          if (type === "option1") {
            it.options[0] = value;
          }
          if (type === "option2") {
            it.options[1] = value;
          }
          if (type === "option3") {
            it.options[2] = value;
          }
          
          if ((item1 && it.options[0] === '')) {
            text = 5
          }
          if ((item2 && it.options[1] === '')) {
            text = 5
          }
          if ((item3 && it.options[2] === '')) {
            text = 5
          }
          return { ...it, productStatus: text };
        } else {
          return it;
        }
      });
      productInfoSet((prevValue)=>{

        const params = prevValue.map((it,i)=>{
          if (it.id === list[i].id) {
            it.options = list[i].options
            it.productStatus = list[i].productStatus
            return it
          }else{
            return it
          }
        })
        return params;
      });
      toggleToast('Saved successfully');
    } else {
      toggleToast(res.msg);
    }
    // onSave("variants");
  };

  // 修改单个变体属性值（value）
  const changeVariantValue = async (item, field, fieldValue) => {
    // const list = _.cloneDeep(data.Variants);
    // _.forEach(list, (el) => {
    _.forEach(origin, (el) => {
      if (el.id === item.id) {
        el[field] = fieldValue;
      }
    });
    setCurrentNum(false);
    setList(origin);
    setOrigin(origin);
    setRuleForm((preState) => {
      let currentData = preState.variants;
      let param = { ...currentData, Variants: origin };
      const params = { ...preState, variants: param };
      return params;
    });
  };

  // 保存单个变体属性值（value）
  const saveVariantValue = async (item, field, fieldValue) => {
    const params = {
      actionType: "variants",
      RecordId: id,
      variantId: item.id,
      field,
      fieldValue,
    };
    const formData = new FormData();
    for (const key in params) {
      formData.append(key, params[key]);
    }
    onSave("variants");
  };

  // 保存物流方式
  const saveShipping = async (lists) => {
    try {
      if (lists.length > 0) {
        const selected = _.find(lists, (item) => {
          return item.selected === 1;
        });
        if (
          selected &&
          // selected.id !== currentShipping.id &&
          selected.service_name !== currentShipping.service_name
        ) {
          const params = {
            actionType: "shipping",
            RecordId: id,
            serviceName: selected.service_name,
          };
          const res = await reqPostDropshipmanNewProductAction(params);
          if (res && res.code === "200") {
            setShippingData(lists);
            toggleToast('Saved successfully');
          } else {
            toggleToast(res.msg);
          }
        } else {
          setShippingData(lists);
        }
      }
    } catch (error) {
      // console.log(showMore);
    }
  };

  const handleScroll = () => {
    var scrollTopHeight = scrollRef.current.scrollTop;
    // 文档显示区域的高度
    var showHeight = height;
    // 所有内容的高度
    var allHeight = tableRef.current?.getBoundingClientRect().height;
    // 只需要判断内容盒子的高度+滚动条的scrollTop = 盒子内容的高度即为触底
    if (scrollTopHeight + showHeight === allHeight) {
      // if (showMore + limit <= data.Variants?.length) {
      // console.log(getShowMore(),limit,origin?.length);
      // if (getShowMore() <= origin?.length) {
      //   setShowMore((prevValue) => {
      //     const newValue = prevValue;
      let arr = _.cloneDeep(list);
      //     arr.push(...origin?.slice(newValue));
      //     setList(arr);
      //     return newValue;
      //   });
      // }
      setList(arr);
    }
  };

  // Price: select change  Ships from
  const handleSelectChange = (value, id) => {
    // if(id === 'Ships_from'){
    //   this.setState({
    //     sendGoodsCountry: value
    //   },()=>{
    //     setTimeout(()=>{
    //       this.getShippingCosts();
    //     },300);
    //   });
    //   return false;
    // }

    if (value !== "0") {
      let isSettingPrice = true;
      if (id === "ChangeAllPriceSelect") {
      } else if (id === "ChangeAllComparedPriceSelect") {
        isSettingPrice = false;
      }
      setChangeAttributeData((prevValue) => ({
        ...prevValue,
        isBulkSettingPrice: isSettingPrice,
        BulkSettingPriceType: value,
      }));
      handleModalChage();
    }
  };
  // 设置价格、倍数因子 input
  const handleSetPriceInputChange = (value, id) => {
    // this.setState({
    //   [id]: value
    // })
    setChangeAttributeData((prevValue) => ({
      ...prevValue,
      [id]: value,
    }));
  };

  // 批量修改 现价 和 原价  change all price (选中才修改)
  const applyChangeAllPrice = async () => {
    let settingValue = getChangeAttributeData()?.PriceSettingValue;
    let _data = origin;

    for (let i = 0; i < _data.length; i++) {
      if (_data[i].checked === 1) {
        // 选中的才修改

        // 设置价格 设置类型 1：统一价格值,2:价格倍数因子c ,price*c
        if (changeAttributeData.isBulkSettingPrice) {
          // 批量设置 现价

          if (changeAttributeData.BulkSettingPriceType === "1") {
            // 赋值
            _data[i].price = parseFloat(settingValue).toFixed(2);
          } else {
            // 相乘
            _data[i].price = parseFloat(_data[i].cost * settingValue).toFixed(
              2
            );
          }
        } else {
          // 批量设置 原价
          if (changeAttributeData.BulkSettingPriceType === "1") {
            _data[i].compared_price = parseFloat(settingValue).toFixed(2);
          } else {
            _data[i].compared_price = parseFloat(
              _data[i].cost * settingValue
            ).toFixed(2);
          }
        }
      }
    }
    setOrigin(_data);

    onSave("variants",'modified');
    handleModalChage();
  };

  // input change
  const handleInputChange = (RecordKey, type, value) => {
    setCurrentNum(false);
    let _data = data?.Variants;

    // 数组中的对象属性用 []  可以识别出来(type是对象的属性)
    _data[RecordKey][type] = value;

    // 遍历对象修改属性
    for (let i in _data[RecordKey]) {
      if (type === i) {
        _data[RecordKey][i] = value;
        break;
      }
    }
    // console.log(RecordKey, type, value);
    setOrigin(_data);
    setRuleForm((preState) => {
      let currentData = preState.variants;
      let param = { ...currentData, Variants: _data };
      const params = { ...preState, variants: param };
      return params;
    });

    // this.setState({
    //   tableData: _data,
    // },()=>{
    //   // 更新列表
    //   this.initPageData();
    // });
  };

  // modal change
  const handleModalChage = () => {
    setChangeAttributeData((prevValue) => ({
      ...prevValue,
      BulkSettingPriceActive: !prevValue.BulkSettingPriceActive,
      PriceSettingValue: "",
    }));
  };

  // [单个变量的值] 后台更新
  const updateSingleValue = async (RecordKey, type) => {
    setCurrentNum(false);
    let _data = data?.Variants;

    let variantId = _data[RecordKey].id;
    let fieldValue = _data[RecordKey][type];

    var params = "";

    // 判断是否能够更新，变体的属性值不能有重复的
    if (
      type === "option_one" ||
      type === "option_two" ||
      type === "option_three"
    ) {
      // 检测变体属性的唯一性（不能存在两个变体，一样的属性）
      // 待检测数组
      let needCheckOptionArray = [];
      // 待检测的属性记录
      let needCheckOptionValue = "";

      for (let i = 0; i < _data.length; i++) {
        if (i === RecordKey) {
          if (type === "option_one") {
            needCheckOptionValue =
              fieldValue +
              "-" +
              _data[i].option_two +
              "-" +
              _data[i].option_three;
          }
          if (type === "option_two") {
            needCheckOptionValue =
              _data[i].option_one +
              "-" +
              fieldValue +
              "-" +
              _data[i].option_three;
          }
          if (type === "option_three") {
            needCheckOptionValue =
              _data[i].option_one +
              "-" +
              _data[i].option_two +
              "-" +
              fieldValue;
          }
        } else {
          needCheckOptionArray.push(
            _data[i].option_one +
              "-" +
              _data[i].option_two +
              "-" +
              _data[i].option_three
          );
        }
      }

      // 检测
      let hasTheSame = false;
      if (needCheckOptionArray.length > 0 && needCheckOptionValue !== "") {
        for (let j = 0; j < needCheckOptionArray.length; j++) {
          if (needCheckOptionValue === needCheckOptionArray[j]) {
            hasTheSame = true;
            break;
          }
        }
      }
      if (hasTheSame) {
        // toggleToast(
        //   intl.get("Another product variant with same option values."),
        //   true
        // );
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:'Another product variant with same option values.'
        }}));
        return false;
      }

      params = {
        actionType: "variants",
        RecordId: id,
        variantId: variantId,
        field: type,
        fieldValue: fieldValue,
      };
    } else if (type === "option1" || type === "option2" || type === "option3") {
      // 修改属性名称
      let checkOptionArr = [];
      let optionData = data.Options;
      let optionValue = "";
      if (type === "option1") {
        optionValue = optionData.option1;
        if (optionData.option2 !== "") {
          checkOptionArr.push(optionData.option2);
        }
        if (optionData.option3 !== "") {
          checkOptionArr.push(optionData.option3);
        }
      }
      if (type === "option2") {
        optionValue = optionData.option2;
        if (optionData.option1 !== "") {
          checkOptionArr.push(optionData.option1);
        }
        if (optionData.option3 !== "") {
          checkOptionArr.push(optionData.option3);
        }
      }
      if (type === "option3") {
        optionValue = optionData.option3;
        if (optionData.option1 !== "") {
          checkOptionArr.push(optionData.option1);
        }
        if (optionData.option2 !== "") {
          checkOptionArr.push(optionData.option2);
        }
      }

      // 检测是否和其他属性名有重复名称
      for (let j = 0; j < checkOptionArr.length; j++) {
        if (optionValue === checkOptionArr[j]) {
          this.toggleToast(
            intl.get("The property names cannot be the same"),
            true
          );
          return false;
        }
      }

      params = {
        actionType: "option",
        RecordId: id,
        type: type,
        value: optionValue,
      };
    } else {
      params = {
        actionType: "variants",
        RecordId: id,
        variantId: variantId,
        field: type,
        fieldValue: fieldValue,
      };
    }
    const response = await reqPostDropshipmanNewProductAction(params);
    if (response.code === "200") {
      toggleToast('Saved successfully', false);
    } else {
      toggleToast(response.msg);
    }
  };

  const [showToast, setShowToast] = useState(false);
  const [showToastText, setShowToastText] = useState("");
  const [showToastIserror, setShowToastIserror] = useState(false);
  //提示弹窗
  const toggleToast = (showToastText, showToastIserror = false) => {
    setShowToast(!showToast);
    setShowToastText(showToastText);
    setShowToastIserror(showToastIserror);
  };

  const toastMarkup = showToast ? (
    <Toast
      content={showToastText}
      onDismiss={() => toggleToast("")}
      error={showToastIserror}
      duration={2000}
    />
  ) : null;

  // 当前选择的物流
  const currentShipping = useMemo(() => {
    let country;
    // 加上国家
    if (data.shippingToCountry === "CN") {
      country = "China";
    } else {
      country = _.get(
        _.find(ShopifyCountriesConfig, (el) => {
          return el.value === data.shippingToCountry;
        }),
        "label"
      );
    }
    const item = _.find(shippingData, (item) => {
      return item.selected;
    });
    return { ...item, country };
  }, [shippingData, data]);
  const BulkEditPriceSettingModal = (
    <Modal
      open={changeAttributeData.BulkSettingPriceActive}
      onClose={handleModalChage}
      title={
        changeAttributeData.isBulkSettingPrice
          ? intl.get("Change all selected variants price")
          : intl.get("Change all selected variants compared at price")
      }
      primaryAction={{
        content: intl.get("Apply"),
        onAction: applyChangeAllPrice,
        disabled: changeAttributeData.PriceSettingValue === "" ? true : false,
      }}
      secondaryActions={[
        {
          content: intl.get("Cancel"),
          onAction: handleModalChage,
        },
      ]}
    >
      <div style={{ padding: "2rem" }}>
        <TextField
          id="PriceSettingValue"
          label={intl.get("Set Value")}
          labelHidden
          onChange={(e) => handleSetPriceInputChange(e, "PriceSettingValue")}
          value={changeAttributeData.PriceSettingValue}
          type="number"
          step={0.01}
          helpText={
            changeAttributeData.BulkSettingPriceType === "1"
              ? intl.get("Set a price to apply to all selected variants")
              : intl.get("eg: 10 * 2 = 20, enter: 2")
          }
        />
      </div>
    </Modal>
  );
  const optionData = (type) => {
    let text = false;
    data.Variants.forEach((it) => {
      if (it[type] !== "") {
        text = true;
      }
    });
    return text;
  };

  // 表格内容
  // const tableNode = _.map(data.Variants, (item) => {
  const tableNode = _.map(getList(), (item, ind) => {
    // 计算利润
    const productProfit = (
      parseFloat(item.price || 0) -
      parseFloat(item.cost || 0) -
      parseFloat(currentShipping.Cost || 0)
    ).toFixed(2);
    return (
      <tr key={ind}>
        <td>
          <Checkbox
            label={t("Single Checkbox")}
            labelHidden
            checked={item.checked}
            onChange={() => handleCheck(item)}
            disabled={data.status || (!item.checked && allSelect())}
          />
        </td>
        <td>
          <PlaceholderImage src={item.image_url} size="58" alt="image" />
        </td>
        <td>
          <TextField label="SKU" labelHidden value={item.sku} disabled />
        </td>
        <td
          style={{
            display:
              data.Options.option1_show || optionData("option_one")
                ? "table-cell"
                : "none",
          }}
        >
          <TextField
            label={t("Option1")}
            labelHidden
            value={String(item.option_one)}
            onChange={(value) => changeVariantValue(item, "option_one", value)}
            onBlur={(event) =>
              saveVariantValue(item, "option_one", event.target.value)
            }
            autoComplete="off"
            disabled={data.status ? true : false}
          />
        </td>
        <td
          style={{
            display:
              data.Options.option2_show || optionData("option_two")
                ? "table-cell"
                : "none",
          }}
        >
          <TextField
            label={t("Option2")}
            labelHidden
            autoComplete="off"
            value={String(item.option_two)}
            onChange={(value) => changeVariantValue(item, "option_two", value)}
            onBlur={(event) =>
              saveVariantValue(item, "option_two", event.target.value)
            }
            disabled={data.status ? true : false}
          />
        </td>
        <td
          style={{
            display:
              data.Options.option3_show || optionData("option_three")
                ? "table-cell"
                : "none",
          }}
        >
          <TextField
            label={t("Option3")}
            labelHidden
            value={String(item.option_three)}
            onChange={(value) =>
              changeVariantValue(item, "option_three", value)
            }
            onBlur={(event) =>
              saveVariantValue(item, "option_three", event.target.value)
            }
            disabled={data.status ? true : false}
          />
        </td>
        <td>
          <div className="flex flex-col">
            <div>
              <span>{data.symbol}</span>
              <span>{Number(item.cost).toFixed(2)}</span>
            </div>
            <div className="text-blue-100">
              {data.isCurrencyConvert === 1
                ? "US$" + item.before_convert_cost.toFixed(2)
                : ""}
            </div>
          </div>
        </td>
        <td>
          <div>
            <div>
              {shippingData.length > 0 ? (
                currentShipping?.Cost !== "0.00" && currentShipping?.Cost ? (
                  <>
                    <span>{data.symbol}</span>
                    <span>{currentShipping?.Cost?.toFixed(2)}</span>
                  </>
                ) : (
                  `${data.symbol}0`
                )
              ) : (
                "N/A"
              )}
            </div>
            {shippingData.length > 0 &&
              currentShipping &&
              currentShipping?.BeforeConvertCost > 0 &&
              data?.isCurrencyConvert === 1 && (
                <div className="text-blue-100">
                  {"US$" + currentShipping.BeforeConvertCost.toFixed(2)}
                </div>
              )}
          </div>
        </td>
        <td>
          <TextField
            label={t("Price")}
            labelHidden
            prefix={data.symbol}
            value={String(item.price)}
            onChange={(value) => changeVariantValue(item, "price", value)}
            onBlur={(event) =>
              saveVariantValue(item, "price", event.target.value)
            }
            disabled={data.status ? true : false}
            placeholder="0.00"
          />
        </td>
        <td>
          <span style={{ color: productProfit < 0 ? "#f72323" : "#46b377" }}>
            <span style={{ display: "inline-block" }}>{data.symbol}</span>
            {productProfit}
          </span>
        </td>
        <td>
          <TextField
            label={intl.get("Compared At Price")}
            labelHidden
            prefix={data?.symbol}
            value={item?.compared_price}
            onChange={(e) => handleInputChange(ind, "compared_price", e)}
            onBlur={() => {
              setTimeout(() => {
                updateSingleValue(ind, "compared_price");
              }, 300);
            }}
            disabled={data.status ? true : false}
            placeholder="0.00"
          />
        </td>
        <td>{item.inventory}</td>
      </tr>
    );
  });

  return (
    <div
      className="product-variant-table"
      style={{ overflowY: hasScroll ? "scroll" : "auto" }}
      ref={scrollRef}
      onScroll={handleScroll}
    >
      {/* <div className="product-variant-table" ref={scrollRef} > */}
      <table ref={tableRef}>
        <thead ref={theadRef}>
          <tr>
            <th colSpan={2}>
              <Checkbox
                label={t("All")}
                checked={isCheckAll}
                onChange={checkAll}
                disabled={data.status}
              />
            </th>
            <th>{t("SKU")}</th>
            <th
              style={{
                display:
                  data.Options?.option1_show || optionData("option_one")
                    ? "table-cell"
                    : "none",
              }}
            >
              <TextField
                label={t("option1")}
                labelHidden
                onChange={(value) => changeAttribute("option1", value)}
                onBlur={(event) => saveAttribute("option1", event.target.value)}
                value={String(data.Options.option1)}
                disabled={data.status}
              />
            </th>
            <th
              style={{
                display:
                  data.Options?.option2_show || optionData("option_two")
                    ? "table-cell"
                    : "none",
              }}
            >
              <TextField
                label={t("option2")}
                labelHidden
                onChange={(value) => changeAttribute("option2", value)}
                onBlur={(event) => saveAttribute("option2", event.target.value)}
                value={String(data.Options.option2)}
                disabled={data.status}
              />
            </th>
            <th
              style={{
                display:
                  data.Options?.option3_show || optionData("option_three")
                    ? "table-cell"
                    : "none",
              }}
            >
              <TextField
                label={t("option3")}
                labelHidden
                onChange={(value) => changeAttribute("option3", value)}
                onBlur={(event) => saveAttribute("option3", event.target.value)}
                value={String(data.Options.option3)}
                disabled={data.status}
              />
            </th>
            <th>{t("Cost")}</th>
            <th>{t("Shipping")}</th>
            <th>{t("Selling Price")}</th>
            <th>{t("Profit")}</th>
            <th>{t("Compared At Price")}</th>
            <th>{t("Inventory")}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            style={{
              top: `${
                Math.floor(theadRef.current?.getBoundingClientRect().height) - 1
              }px`,
            }}
          >
            <td colSpan={3}></td>
            <td
              style={{
                display:
                  data.Options.option1_show || optionData("option_one")
                    ? "table-cell"
                    : "none",
              }}
            >
              <Button
                fullWidth
                disabled={checkNum === 0 || data.status === 1 ? true : false}
                onClick={() => openAttribute("option_one")}
              >
                {t("Change Selected")}
              </Button>
            </td>
            <td
              style={{
                display:
                  data.Options.option2_show || optionData("option_two")
                    ? "table-cell"
                    : "none",
              }}
            >
              <Button
                fullWidth
                disabled={checkNum === 0 || data.status === 1 ? true : false}
                onClick={() => openAttribute("option_two")}
              >
                {t("Change Selected")}
              </Button>
            </td>
            <td
              style={{
                display:
                  data.Options.option3_show || optionData("option_three")
                    ? "table-cell"
                    : "none",
              }}
            >
              <Button
                fullWidth
                disabled={checkNum === 0 || data.status === 1 ? true : false}
                onClick={() => openAttribute("option_three")}
              >
                {t("Change Selected")}
              </Button>
            </td>
            <td colSpan={2} style={{ textAlign: "right" }}>
              <Button
                variant="plain"
                disclosure={showShipping ? "up" : "down"}
                onClick={() => setShowShipping(true)}
                loading={searchingShip}
                disabled={data.status}
              >
                <div>
                  {/* 显示国家，超过20个字符则显示为... */}
                  {currentShipping && currentShipping.country && (
                    <>
                      <span>{currentShipping.country.substring(0, 20)}</span>
                      <span>
                        {currentShipping.country.length > 20 ? "..." : ""}
                      </span>
                    </>
                  )}
                </div>
                <div>
                  {/* 显示物流名称，没有物流则显示N/A, 超过24个字符则显示... */}
                  {currentShipping ? (
                    <>
                      {currentShipping.ShippingMethod && (
                        <>
                          <span>
                            {currentShipping.ShippingMethod.substring(0, 24)}
                          </span>
                          <span>
                            {currentShipping.ShippingMethod.length > 24
                              ? "..."
                              : ""}
                          </span>
                        </>
                      )}
                    </>
                  ) : (
                    "N/A"
                  )}
                </div>
              </Button>
            </td>
            <td>
              <Select
                id="ChangeAllPriceSelect"
                label={t("Price")}
                labelHidden
                options={[
                  { label: t("Change Selected"), value: "0" },
                  { label: t("Set New Value "), value: "1" },
                  { label: t("Multiply by "), value: "2" },
                ]}
                onChange={(e) => handleSelectChange(e, "ChangeAllPriceSelect")}
                disabled={checkNum === 0 || data.status === 1 ? true : false}
                value={changeAttributeData.ChangeAllPriceSelect}
              />
            </td>
            {/* <td>
              <Button
                fullWidth
                disabled={data.status}
                onClick={() => openAttribute("price")}
              >
                {t("Change Selected")}
              </Button>
            </td> */}
            <td></td>
            <td>
              <Select
                id="ChangeAllComparedPriceSelect"
                label={t("Compare Price")}
                labelHidden
                options={[
                  { label: t("Change Selected"), value: "0" },
                  { label: t("Set New Value "), value: "1" },
                  { label: t("Multiply by "), value: "2" },
                ]}
                onChange={(e) =>
                  handleSelectChange(e, "ChangeAllComparedPriceSelect")
                }
                disabled={checkNum === 0 || data.status === 1 ? true : false}
                value={changeAttributeData.ChangeAllComparedPriceSelect}
              />
            </td>
            <td></td>
          </tr>
          {tableNode}
        </tbody>
      </table>

      {/* 批量修改属性值 */}
      <EditAttribute
        isShow={showAttribute}
        field={currentField}
        onClose={() => setShowAttribute(false)}
        onConfirm={batchChangeAttribute}
      />

      {/* 物流方式 */}
      <Shipping
        isShow={showShipping} // 弹窗是否显示
        tableData={shippingData} // 物流列表
        productInfo={data} // 商品详情
        id={id}
        setRuleForm={setRuleForm}
        onClose={() => setShowShipping(false)}
        onConfirm={saveShipping}
        setShippingData={setShippingData}
      />
      {/* 编辑价格弹窗 */}
      {BulkEditPriceSettingModal}
      {/* 提示弹窗 */}
      {toastMarkup}
    </div>
  );
};

export default VariantsTable;
